/**
 * #2519: the closed codes an `access.revoke` row records in `metadata.reason` in place of a typed
 * reason, and the Audit trail drawer's words for each. `replaced` is a role change's automatic
 * revoke (`AccessService`); the others end a group access override (`server/auth/groupAccess.ts`,
 * `server/routes/groupAccess.ts`). A writer that records a new code adds it here, so the drawer
 * never shows a code as the reason.
 */
export const ACCESS_REVOKE_REASON_WORDS = {
  replaced: "Replaced by a new role.",
  left_group: "The person left the directory group.",
  mapping_removed: "The directory group's role mapping was removed.",
  override_replaced: "The role set for this person was replaced by a new one.",
  override_cleared: "The role set for this person was cleared.",
} as const satisfies Record<string, string>;

export type AccessRevokeReasonCode = keyof typeof ACCESS_REVOKE_REASON_WORDS;

export function isAccessRevokeReasonCode(value: unknown): value is AccessRevokeReasonCode {
  return typeof value === "string" && Object.hasOwn(ACCESS_REVOKE_REASON_WORDS, value);
}
